import {forwardRef, useEffect, useImperativeHandle, useRef, useState} from "react";
import {IconClose} from "../../Icon";
import {Button, Checkbox, ConfigProvider, message, Modal} from "antd";
import {t} from "i18next";
import Cropper from "cropperjs";
import {IMAGE_MIME_TYPES} from "../../../@excalidraw/packages/excalidraw/constants";
import {ipcInvoke} from "@/common/ipc";
import {generateUUID2} from "@/utils";
import global from "@/global";

const DialogImageCrop = forwardRef((props:{onCloseCallback:any}, ref) => {
    useImperativeHandle(ref, () => ({
        onShowDialog: onShowDialog
    }))
    const [isShowDialog, setIsShowDialog] = useState(false);
    const [imagePath,setImagePath] = useState('');

    const mCropper = useRef<Cropper>(null);
    const imgRef = useRef(null);
    const mCallback = useRef(null);
    const mImagePath = useRef(null);
    const mRate = useRef<number>(1.47);

    const onShowDialog = (szImagePath:any,callback:any,rate = 1.47)=>{
        setIsShowDialog(true);
        mImagePath.current = (szImagePath);
        mCallback.current = callback;
        mRate.current = rate || 1.47;
    }

    useEffect(() => {

        global.g_showDialogs['dialogImageCrop'] = true;

        return () => {
            global.g_showDialogs['dialogImageCrop'] = false;
            mCropper.current?.destroy();
        };
    }, []);


    const onOk = ()=>{
        mCropper.current?.crop();
        const rectangleShape = mCropper.current?.getCroppedCanvas();
        const croppedCanvas = rectangleShape;
        const base64 = croppedCanvas.toDataURL(IMAGE_MIME_TYPES.png);
        const szFileName = generateUUID2()+'.png';
        ipcInvoke('write-base64-image', {fileName:szFileName,imgBase64:base64}).then(res => {
            mCallback.current("localfile://"+res);
            props.onCloseCallback();
        });

        return croppedCanvas;
    }

    return <Modal width={720} zIndex={2005} bodyStyle={{height: `${660}px`}}
                  afterClose={() => {
                      props.onCloseCallback();
                  }}
                  open={true} centered={true} closable={true} closeIcon={<IconClose/>} footer={null}
                  onCancel={() => {
                      props.onCloseCallback();
                  }}>
        <div style={{height: '100%', width: '100%', display: 'flex', flexDirection: 'column'}}>
            <div className={'flex-row-vertical-center'} style={{flexShrink: '0'}}>
                <span className={'dialog-title'}>{t("Change thumbnail")}</span>
                <div style={{flexGrow: '1'}}/>
            </div>
            <div className={'line mt-12'} style={{margin: '12px -22px'}}></div>

            <div className="img-container"  style={{width:'100%',height:'540px'}}>
                <img
                    ref={imgRef}
                    src={mImagePath.current}
                    alt="img"
                    onLoad={()=>{
                        //必须要图片加载完成才能初始化----imagecropper.tsx中为什么要写在useeffect里面呢？？
                        const cropper = new Cropper(imgRef.current!, {
                            // autoCropArea: 1,
                            aspectRatio:mRate.current,

                            ready() {
                                mCropper.current = (cropper);
                            }
                        });
                    }}
                    // style={{ maxWidth: "100%" }}
                />
            </div>

            <div className={'flex-center mt-32 mb-4'}>
                <Button
                    style={{height: '34px', minWidth: '120px'}}
                    className='large-w-button button-border-gray-style font-size-14 font-family-medium'
                    onClick={() => {
                        props.onCloseCallback();
                    }}>{t("Cancel")}</Button>
                <Button
                    // disabled={isStringNullOrEmpty(selectFile)}
                    className='large-w-button button-solid-style font-size-14 font-family-medium'
                    type="primary"
                    onClick={async () => {
                        onOk();
                    }}
                    style={{
                        marginLeft: '62px',
                        minWidth: '120px'
                    }}
                    htmlType={"submit"}>{t("Import")}</Button>
            </div>
        </div>
    </Modal>
})

export default DialogImageCrop;